import notificationService from "../services/NotificationService";
import moment from "moment";
import dayjs from "dayjs";
class NotificationFilter {
  momentToFormat = (m) => (m ? m.format("YYYY-MM-DD") : "");

  async createCsv(listname, userId, tags, userGroup, date, filters) {
    try {
      if (!userGroup) {
        userGroup = "";
      }

      const date1 = new Date();
      const createDate = moment(date1).format("DD_MM_YYYY_h_mmA");
      const response = await notificationService.createCsv(
        listname,
        userId,
        createDate,
        tags,
        userGroup,
        this.momentToFormat(date),
        filters
      );

      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async createExcel(listname, userId, tags, userGroup, date, filters) {
    try {
      if (!userGroup) {
        userGroup = "";
      }

      const date1 = new Date();
      const createDate = moment(date1).format("DD_MM_YYYY_h_mmA");
      const response = await notificationService.createExcel(
        listname,
        userId,
        createDate,
        tags,
        userGroup,
        this.momentToFormat(date),
        filters
      );

      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async downloadDetails(userId) {
    try {
      const response = await notificationService.downloadDetails(userId);

      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async deleteDownloadDetails(id) {
    try {
      const response = await notificationService.deleteDownloadDetails(id);

      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async getCount(userId) {
    try {
      const response = await notificationService.getCount(userId);

      return response;
    } catch (err) {
      console.log(err);
    }
  }

  async downloadCsv(id, listname) {
    try {
      const response = await notificationService.downloadCsv(id, listname);

      return response;
    } catch (err) {
      console.log(err);
    }
  }

  async downloadExcel(id, listname) {
    try {
      const response = await notificationService.downloadExcel(id, listname);

      return response;
    } catch (err) {
      console.log(err);
    }
  }
}

const notificationFilter = new NotificationFilter();

export default notificationFilter;
